export const learnMoreContent = {
  lt: {
    title: "Kodėl verta rinktis Kiemo Priežiūrą?",
    sections: [
      {
        icon: "🎯",
        heading: "Pritaikyta Lietuvos klimatui",
        text: "Mūsų augalų priežiūros rekomendacijos ir priminimai yra specialiai pritaikyti Lietuvos oro sąlygoms. Sistema atsižvelgia į mūsų keturis sezonus, šalnas, lietingus periodus ir kitus vietinius klimato ypatumus."
      },
      {
        icon: "📱",
        heading: "Paprasta ir intuityvi",
        text: "Nesvarbu, ar esate pradedantysis sodininkas, ar patyręs augalų mylėtojas - mūsų aplikacija sukurta taip, kad ja būtų patogu naudotis kiekvienam. Aiški navigacija, paprastos funkcijos ir draugiška sąsaja."
      },
      {
        icon: "🌱",
        heading: "Viskas vienoje vietoje",
        list: [
          "Augalų katalogas su detaliais aprašymais",
          "Personalizuoti priežiūros planai",
          "Automatiniai priminimai apie laistymus ir tręšimus",
          "Nuotraukų albumas augalų progresui sekti",
          "Orų prognozė su sodininkavimo patarimais"
        ]
      },
      {
        icon: "💚",
        heading: "Auginkite su pasitikėjimu",
        text: "Daugiau nei 2000 lietuvių jau naudojasi mūsų aplikacija ir sėkmingai prižiūri savo augalus. Prisijunkite prie augančios bendruomenės!"
      },
      {
        icon: "🎁",
        heading: "Nemokama pradžia",
        text: "Išbandykite visas pagrindines funkcijas nemokamai. Premium funkcijos atrakina dar daugiau galimybių tiems, kurie nori maksimaliai išnaudoti aplikacijos potencialą."
      }
    ],
    premiumTitle: "⭐ Ką gausite su Premium?",
    premiumFeatures: [
      "Neriboti augalai - pridėkite kiek norite augalų",
      "AI augalų atpažinimas - nufotografuokite ir sužinokite augalo rūšį",
      "7 dienų orų prognozė - planuokite darbus iš anksto",
      "Išplėstinė analitika - sekite augalų augimo tendencijas",
      "Be reklamų - naudokitės be pertraukčių"
    ]
  },
  en: {
    title: "Why Choose Yard Care?",
    sections: [
      {
        icon: "🎯",
        heading: "Adapted for Lithuanian Climate",
        text: "Our plant care recommendations and reminders are specifically tailored to Lithuanian weather conditions. The system takes into account our four seasons, frosts, rainy periods, and other local climate characteristics."
      },
      {
        icon: "📱",
        heading: "Simple and Intuitive",
        text: "Whether you're a beginner gardener or an experienced plant lover - our app is designed to be comfortable for everyone to use. Clear navigation, simple features, and a friendly interface."
      },
      {
        icon: "🌱",
        heading: "Everything in One Place",
        list: [
          "Plant catalog with detailed descriptions",
          "Personalized care plans",
          "Automatic reminders for watering and fertilizing",
          "Photo album to track plant progress",
          "Weather forecast with gardening tips"
        ]
      },
      {
        icon: "💚",
        heading: "Grow with Confidence",
        text: "More than 2000 Lithuanians already use our app and successfully care for their plants. Join the growing community!"
      },
      {
        icon: "🎁",
        heading: "Free to Start",
        text: "Try all basic features for free. Premium features unlock even more possibilities for those who want to maximize the app's potential."
      }
    ],
    premiumTitle: "⭐ What You Get with Premium?",
    premiumFeatures: [
      "Unlimited plants - add as many plants as you want",
      "AI plant identification - take a photo and identify the plant species",
      "7-day weather forecast - plan your work in advance",
      "Advanced analytics - track plant growth trends",
      "Ad-free - use without interruptions"
    ]
  }
}; 